<template>
  <div class="uk-width-1-1 text-style" :class="{'top-margin': !isMobile}">
    <p >{{$t('general.shareResource')}}</p>
    <div class="uk-display-inline-block" v-for="(icon,index) in ICONS">
      <img v-if="iconHoverState !== icon" :src="resolveIcon(icon)" class="uk-width-1-4 add-pointer" :id="icon.toLowerCase()"
           @mouseover="onHover(icon)"/>
      <img v-else  class="uk-width-1-4 add-pointer" :src="resolveIcon(`${icon}_HOVER`)" @click="share(icon)"
           @mouseleave="onLeave(icon)" :id="icon.toLowerCase()"/>
    </div>
  </div>
</template>

<script>
  import iconUtil from '@/utils/icon-util'
  import * as socialMedia from '@/enums/social-media'
  import mixpanel from '@/services/mixpanel'
  import {SHARED_TO_TWITTER, SHARED_TO_FACEBOOK, SHARED_TO_EMAIL, SHARED_TO_PINTEREST} from '@/enums/mixpanel-event'
  import {TWEET, FB_SHARE, PINTEREST} from '@/enums/static-urls'
  import screenUtil from '@/utils/screen-util'
  import {ROUTE_NAME_PREVIEW} from '@/enums/routes'

  export default {
    name: 'social-media-sharing',
    props: {
      contentDetail: {
        type: Object,
        default: {}
      },
      isMobile: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        ICONS: [socialMedia.FACEBOOK, socialMedia.PINTEREST, socialMedia.TWITTER, socialMedia.EMAIL],
        pinterestImagePath: '/static/custom-icons/social-media/pinterest-share-image.jpg',
        iconHoverState: ''
      }
    },
    methods: {
      onLeave() {
        this.iconHoverState = ''
      },
      onHover(icon) {
        this.iconHoverState = icon
      },
      resolveIcon(icon) {
        return iconUtil.resolve(icon)
      },
      share(icon) {
        switch (icon) {
          case socialMedia.TWITTER:
            this.toTwitter()
            break
          case socialMedia.FACEBOOK:
            this.toFacebook()
            break
          case socialMedia.EMAIL:
            this.toEmail()
            break
          case socialMedia.PINTEREST:
            this.toPinterest()
            break
        }
      },
      toTwitter() {
        mixpanel.track(SHARED_TO_TWITTER, {contentId: this.$route.params.id})
        window.open(this.resolveTweetUrl(this.resolveUrl()), '_blank')
      },
      toPinterest() {
        mixpanel.track(SHARED_TO_PINTEREST, {contentId: this.$route.params.id})
        window.open(this.resolvePinterestUrl(this.resolveUrl()), '_blank')
      },
      toFacebook() {
        mixpanel.track(SHARED_TO_FACEBOOK, {contentId: this.$route.params.id})
        if (screenUtil.resolveWidth() > 1024) {
          window.open(this.resolveFacebookUrl(this.resolveUrl()), 'pop', screenUtil.popupParams(600, 400))
        } else {
          window.open(this.resolveFacebookUrl(this.resolveUrl()), '_blank')
        }
      },
      toEmail() {
        mixpanel.track(SHARED_TO_EMAIL, {contentId: this.$route.params.id})
        document.location = this.resolveEmail(this.resolveUrl())
      },
      resolvePinterestUrl(resourceUrl) {
        return PINTEREST + `url=${resourceUrl}&media=${this.resolveImagePath(this.pinterestImagePath)}&description=${this.contentDetail.title + this.$t('socialMediaMessages.pinterest')}`
      },
      resolveTweetUrl(resourceUrl) {
        return TWEET + this.$t('socialMediaMessages.twitter') + this.contentDetail.title + ': ' + resourceUrl
      },
      resolveFacebookUrl(resourceUrl) {
        return FB_SHARE + resourceUrl
      },
      resolveEmail(resourceUrl) {
        let subject = this.contentDetail.title + ' ' + this.$t('socialMediaMessages.emailSubject')
        let body = encodeURIComponent(this.$t('socialMediaMessages.emailBody1') + resourceUrl + this.$t('socialMediaMessages.emailBody2'))
        return 'mailto:' + '?subject=' + subject + '&body=' + body
      },
      resolveImagePath(path) {
        return window.location.origin + path
      },
      resolveUrl() {
        let url = null
        if (this.$route.name !== ROUTE_NAME_PREVIEW) {
          url = window.location.origin + '/preview/' + this.contentDetail.contentId
        } else {
          url = window.location.href
        }
        let prodRemovedUrl = url.replace('-prod', '')
        return prodRemovedUrl
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours.scss';
  @import '../../../styles/breakpoints.scss';

  .top-margin {
    margin-top: 28px;
  }

  .text-style {
    font-size: 16px;
    color: $content-text;
  }

  img {
    height: 40px;
    width: 40px;
    margin: 10px;
  }

  @media screen and(max-width: $breakpoint-small) {

    img {
      height: 25px;
      width: 25px;
      margin: 5px;
    }
  }
</style>
